import { createApp } from 'vue';
import FlacToMp3Converter from '@/Components/FlacToMp3Converter.vue';
import '@styles/app.css';

createApp(FlacToMp3Converter).mount('#flac-to-mp3-converter');
